import axios from "axios";
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../Components/Loader";
import { Alert } from "../Components/Modal/Alert";
import { useEntidade } from "../Hooks/EntidadeHook";
import { API } from "../Services/Api";
import {
  aplicacao,
  app_base_url,
  enderecos_api,
  login_api,
} from "../Utils/Urls";

interface IPagamentoContextData {
  loading: boolean;
  pagamentos: Pagamento[];
  ano: number;
  setAno: React.Dispatch<React.SetStateAction<number>>;
  getPagamentos: (ano?: number) => Promise<void>;
}

interface IPagamentoProviderProps {
  children: ReactNode;
}

export interface Pagamento {
  empenho: string;
  credor: string;
  data_liquidacao: string;
  data_pagamento: string;
  empenhado: number;
  liquidado: number;
  pago: number;
  a_pagar: number;
}

const PagamentoContext = createContext({} as IPagamentoContextData);
function PagamentoProvider({ children }: IPagamentoProviderProps) {
  const { entidade } = useEntidade();

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ titulo: "", mensagem: "" });

  const [pagamentos, setPagamentos] = useState([] as Pagamento[]);
  const [ano, setAno] = useState(new Date().getFullYear());
  // useEffect(() => {
  //   if (entidade.id) {
  //     getPagamentos();
  //   }
  // }, [entidade]);

  async function getPagamentos(ano?: number) {
    try {
      setLoading(true);
      const { data } = await API.post(
        `/porAno/${ano ? ano : new Date().getFullYear()}`,
        {
          banco: {
            banco: entidade.banco.replace("1-", "").replace("2-", ""),
            numero: entidade.banco.substring(0, 1),
          },
        }
      );

      setPagamentos(data.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <PagamentoContext.Provider
      value={{
        loading,
        pagamentos,
        ano,
        setAno,
        getPagamentos,
      }}
    >
      <>
        {children}

        <Loader loading={loading} />
        <Alert
          alert={alert}
          onClose={() => setAlert({ titulo: "", mensagem: "" })}
          open={alert.mensagem.length > 0}
        />
      </>
    </PagamentoContext.Provider>
  );
}

function usePagamento() {
  const context = useContext(PagamentoContext);

  return context;
}

export { PagamentoProvider, usePagamento };
